import { render, staticRenderFns } from "./JiebanHeyueDetail.vue?vue&type=template&id=778aae98&scoped=true&"
import script from "./JiebanHeyueDetail.vue?vue&type=script&lang=js&"
export * from "./JiebanHeyueDetail.vue?vue&type=script&lang=js&"
import style0 from "./JiebanHeyueDetail.vue?vue&type=style&index=0&id=778aae98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778aae98",
  null
  
)

export default component.exports